export default __webpack_public_path__ + "static/media/summary-chevron-right.bd6f57c8.svg";